export default __webpack_public_path__ + "static/media/gonfalone.af69ef20.jpg";